// Entra identifiers for the "Ask HR" app registration (infra/entra outputs). Public values:
// every sign-in page shows them. A build can override them with VITE_* variables.

const env = import.meta.env;

export const tenantId: string = env.VITE_TENANT_ID ?? "dc96dfb4-2cfd-4244-8e49-33d252646b03";
export const clientId: string = env.VITE_CLIENT_ID ?? "0c2aa81e-fc25-4707-92c8-786d837285ba";
export const apiScope = `api://${clientId}/access_as_user`;

// Ask HR is in testing: the About page says so and asks for thumbs up/down. On unless a build
// sets VITE_TESTING=false.
export const testing: boolean = env.VITE_TESTING !== "false";

// The anonymous reporting hotline, for the button under answers about harassment, discrimination,
// safety, ethics or retaliation. Not set: no button (the notice still names the hotline).
export const hotlineUrl: string = env.VITE_HOTLINE_URL ?? "";
